"use client";
import { useWeb3State } from "@/web3/context";
import usePaymentCurrency from "./usePaymentCurrency";
import { NativeCurrenciesPerChain } from "../constants";

const useNativePaymentCurrency = () => {
  const { network } = useWeb3State();

  return usePaymentCurrency(NativeCurrenciesPerChain[network]);
};

export default useNativePaymentCurrency;
